import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getCachedAccessToken } from "shared/src/utils/cachedAuthSession";
import { createEnhancedApolloErrorLink } from "./apolloErrorLink";

const graphQLUrl = import.meta.env.VITE_GRAPHQL_URL;

const httpLink = createHttpLink({ uri: graphQLUrl });

const authLink = setContext(async (_, { headers }) => {
  const token = await getCachedAccessToken();

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const errorLink = createEnhancedApolloErrorLink();

const graphQLClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorLink.concat(authLink.concat(httpLink)),
  devtools: {
    enabled: false,
  },
});

export default graphQLClient;
